"use client";

import { FC, type JSX } from "react";
import { SectionProps } from "../Section";
import { PortableText } from "@/portable-text/PortableText";
import { ContentData } from "@/cms/types";
import { AccordionSectionQueryResult } from "@/cms/sanity.types";
import { Section } from "@/components/Section";
import {
  Accordion,
  Container,
  Typography,
} from "@cappelendamm/design-system/react";
import { theme } from "@/theming/themed-stylesheet";
import { SanityIcon } from "@/cms/icons/Icon";

export type AccordionSectionProps = ContentData<AccordionSectionQueryResult> &
  Omit<SectionProps, "_id">;

export const AccordionSection: FC<
  AccordionSectionProps & JSX.IntrinsicElements["section"]
> = ({
  data: { _id, internalTitle, accordions, title, stylesheet },
  index,
}) => {
  return (
    <Container
      as={Section}
      style={theme(stylesheet)}
      className="grid gap-3"
      trackingData={{
        ui: {
          item_id: _id ?? "section-id-missing",
          item_name:
            internalTitle?.replaceAll(" ", "-") ?? "section-title-missing",
          item_type: "accordion-section",
          index: index,
        },
      }}
    >
      <Typography as="h3" variant="title-xl">
        {title}
      </Typography>
      {accordions?.map(
        ({ _id, title, icon, accordionText }, accordionIndex) => (
          <Accordion
            key={`${_id}-${accordionIndex}`}
            icon={<SanityIcon data={icon} />}
            title={title}
          >
            <div className="prose">
              <PortableText value={accordionText ?? []} />
            </div>
          </Accordion>
        ),
      )}
    </Container>
  );
};
